module.exports = __webpack_public_path__ + "static/media/mobile.7bd37d6d.png";